<template>
  <aside class="w-64 bg-white border-r border-slate-200 flex flex-col justify-between p-4 shrink-0 h-screen sticky top-0 z-30">
    <div class="flex flex-col gap-8">
      <div class="flex gap-3 items-center px-2">
        <div class="flex items-center justify-center text-primary">
          <span class="material-symbols-outlined text-3xl">circle_circle</span>
        </div>
        <div class="flex flex-col">
          <h1 class="text-pharma-text-main text-base font-bold leading-none">Palmiges Portal</h1>
          <p class="text-pharma-text-muted text-[11px] font-medium mt-1">Admin</p>
        </div>
      </div>

      <nav class="flex flex-col gap-1">
        <router-link to="/dashboard" class="nav-link" active-class="active-nav">
          <span class="material-symbols-outlined text-[20px]">dashboard</span>
          <span class="text-sm font-semibold">Dashboard</span>
        </router-link>

        <router-link to="/patients" class="nav-link" active-class="active-nav">
          <span class="material-symbols-outlined text-[20px]">group</span>
          <span class="text-sm font-semibold">Patients</span>
        </router-link>

        <router-link to="/staff" class="nav-link" active-class="active-nav">
          <span class="material-symbols-outlined text-[20px]">groups</span>
          <span class="text-sm font-semibold">Staff</span>
        </router-link>

        <router-link to="/analytics" class="nav-link" active-class="active-nav">
          <span class="material-symbols-outlined text-[20px]">analytics</span>
          <span class="text-sm font-semibold">Analytics</span>
        </router-link>
      </nav>
    </div>

    <div class="mt-auto pt-4 border-t border-slate-50">
      <button 
        @click="showLogoutModal = true"
        class="flex w-full items-center justify-center rounded-lg h-11 px-4 bg-slate-100 text-pharma-text-muted text-sm font-bold hover:bg-slate-200 transition-all gap-2"
      >
        <span class="material-symbols-outlined text-[20px] rotate-180">logout</span>
        <span>Logout</span>
      </button>
    </div>

    <Teleport to="body">
      <div v-if="showLogoutModal" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-md transition-opacity duration-300" @click="showLogoutModal = false"></div>
        
        <div class="relative bg-white rounded-3xl w-full max-w-md shadow-2xl p-8 text-center animate-in zoom-in duration-200">
          <div class="flex items-center justify-center w-14 h-14 bg-red-50 rounded-full mb-6 mx-auto text-red-600">
            <span class="material-symbols-outlined text-3xl font-bold">logout</span>
          </div>
          
          <h3 class="text-xl font-bold text-pharma-text-main mb-2 tracking-tight">Confirm Logout</h3>
          <p class="text-sm text-pharma-text-muted mb-8 font-medium">
            Are you sure you want to end your current session? You will need to log in again to access the portal.
          </p>

          <div class="flex gap-4">
            <button 
              @click="showLogoutModal = false" 
              class="flex-1 py-3 text-sm font-bold text-pharma-text-main bg-gray-100 rounded-xl hover:bg-gray-200 transition"
            >
              Cancel
            </button>
            <button 
              @click="confirmLogout" 
              class="flex-1 py-3 text-sm font-bold text-white bg-red-600 rounded-xl hover:bg-red-700 shadow-lg shadow-red-200 transition"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </aside>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'AppSidebar',
  data() {
    return {
      showLogoutModal: false
    }
  },
  methods: {
    confirmLogout() {
      // Clear storage
      localStorage.removeItem('user-token');
      localStorage.setItem('user-data', '');
      localStorage.removeItem('user'); // Also clear the user object used by Topbar

      // Reset Axios
      if (api.defaults.headers.common['Authorization']) {
        delete api.defaults.headers.common['Authorization'];
      }

      this.showLogoutModal = false;
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
/* (Styles remain the same) */
.nav-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  color: #676f83; 
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  text-decoration: none;
}
.nav-link:hover {
  background-color: #f1f2f4;
  color: #121317;
}
.active-nav {
  background-color: #3C64CF15 !important;
  color: #3C64CF !important;
}
.active-nav .material-symbols-outlined {
  font-variation-settings: 'FILL' 1;
}
.material-symbols-outlined {
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}
</style>